import type { CopyShape } from "@tami/core/intl";

import type { WEB_ERRORS_COPY_PT_BR } from "../web-errors.copy";

export const WEB_ERRORS_COPY_EN_US: CopyShape<typeof WEB_ERRORS_COPY_PT_BR> = {
  unexpected: "Something unexpected went wrong. Please try again.",
  sessionNotFound: "Session not found",
  sessionNotFoundDot: "Session not found.",
  passwordVerifyFailed: "We couldn't verify your password",
  sessionRenewFailed: "We couldn't renew your session.",
  signUpFailed: "Sign-up failed",
  uploadImageFailed: "We couldn't upload the image.",
  uploadImageFailedRetry: "We couldn't upload the image. Try again.",
  roteiroLoadFailed: "We couldn't load the script. Try again.",
  invalidDate: "Invalid date",
  collabNoAccess: "You don't have access to this creator's content.",
  widget: {
    title: "Something went wrong",
    description: "We couldn't load this info.",
    retry: "Try again",
  },
};
